import { useEffect } from "react";
import Features from "../../components/home/Features.jsx";
import Hero from "../../components/home/Hero.jsx";

const Home = () => {
  useEffect(() => {
    document.title = "VisualLab – Learn with Interactive Visualizations";

    let desc = document.querySelector('meta[name="description"]');
    if (!desc) {
      desc = document.createElement("meta");
      desc.name = "description";
      document.head.appendChild(desc);
    }
    desc.content =
      "VisualLab helps you understand complex concepts through interactive animations and visual explanations.";

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = window.location.origin;
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.name = "robots";
      document.head.appendChild(robots);
    }
    robots.content = "index, follow";
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "VisualLab",
      url: window.location.origin,
      description: "Interactive visual learning platform for complex concepts",
    });

    document.head.appendChild(script);
    return () => document.head.removeChild(script);
  }, []);

  return (
    <>
      <Hero />
      <Features />
    </>
  );
};

export default Home;
